import { ArrowUpward } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useEffect } from "react";

export const ScrollTopButton = () => {
  const [showScrollTop, setShowScrollTop] = React.useState(false);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 0);
    // initialize
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      role="button"
      aria-label="scroll to top"
      sx={{
        position: "fixed",
        right: 24,
        bottom: 24,
        width: 44,
        height: 44,
        bgcolor: "primary.main",
        color: "#fff",
        borderRadius: "50%",
        display: showScrollTop ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: 3,
        cursor: "pointer",
        zIndex: 1300,
      }}
    >
      <ArrowUpward />
    </Box>
  );
};
